export const COMMON_STRINGS = {
  // 🌐 API
  SERVER_ERROR: "Server error, please try again",
  NETWORK_ERROR: "Network error, check your internet",
  UNAUTHORIZED: "Session expired, please login again",
  FORBIDDEN: "You are not allowed to perform this action",
  NOT_FOUND: "Resource not found",

  // 🔘 BUTTONS
  BTN_CONFIRM: "Confirm",
  BTN_CANCEL: "Cancel",
};

export const APP_STRINGS = {
  APP_NAME: "DSA Panel",
};

export const MENU_STRINGS = {
  DASHBOARD: "Dashboard",
  LEADS: "Enquiries",
  CREDIT: "Credit",
  disbursement: "Disbursement",
  BANK_DISBURSEMENT: "Bank Disbursement",
  COMMISSION: "Commission",
  LOGOUT: "Logout",
};

/* 🔥 ONLY RELEVANT STATUS */
export const STATUS_CONFIG = {
  PENDING: {
    value: "pending",
    label: "Pending",
    bg: "var(--warning-soft)",
    color: "var(--warning)",
  },

  APPROVED: {
    value: "approved",
    label: "Approved",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  REJECTED: {
    value: "rejected",
    label: "Rejected",
    bg: "var(--danger-soft)",
    color: "var(--danger)",
  },

  DISBURSED: {
    value: "disbursed",
    label: "Disbursed",
    bg: "var(--blue-soft)",
    color: "var(--blue)",
  },

  READ: {
    value: "read",
    label: "Read",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  UNREAD: {
    value: "unread",
    label: "Unread",
    bg: "var(--warning-soft)",
    color: "var(--warning)",
  },
  LOGIN: {
    value: "login",
    label: "Login",
    color: "#0ea5e9",
    bg: "#e0f2fe",
  },
  CREDIT: {
    value: "credit",
    label: "Credit",
    bg: "#dcfce7",
    color: "#16a34a",
  },
};

export const DASHBOARD_STRINGS = {
  FILTERS: "Filters",
  APPLY: "Apply",
  SELECT_PRODUCT: "Select Product",

  RECENT_LEADS: "Recent Enquiries",
  NO_DATA: "No Data",

  TABLE: {
    NAME: "Name",
    MOBILE: "Mobile",
    PRODUCT: "Product",
    STATUS: "Status",
  },

  CARDS: {
    APPLICATIONS: "Applications",
    APPROVED: "Approved",
    DISBURSED: "Disbursed",
    UNDER_REVIEW: "Under Review",
  },

  CHART: "Performance",

  CURRENCY_SYMBOL: "₹",
};
